
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.83 14.614c.02-.01.036-.018.045-.024.335-.199.909-.758 1.337-1.417.385-.594.638-1.243.415-1.679l-.014-.028c-.273-.345-.798-.77-1.353-1.14-.617-.415-1.24-.745-1.556-.812-.085-.017-.202.068-.322.193-.288.3-.509.773-.606 1.059-.401 1.175-1.555 1.32-2.903.877-.794-.261-1.667-.738-2.46-1.316C6.62 9.752 5.9 9.071 5.408 8.4c-.836-1.142-1.044-2.275-.03-2.991.248-.176.643-.525.85-.884.087-.15.134-.285.092-.359-.157-.276-.664-.762-1.25-1.22-.525-.41-1.097-.779-1.516-.932-.018-.004-.034-.007-.048-.008-.485-.062-1.034.359-1.49.885-.505.58-.874 1.262-.97 1.643a.692.692 0 00-.015.068c-.156 1.17.324 2.37 1.056 3.463 1.198 1.787 3.057 3.278 4.023 3.959.798.563 2.282 1.592 3.94 2.282 1.593.662 3.352 1.014 4.782.306l-.002.002z","fill":"#0C5385"}}),_c('path',{attrs:{"d":"M6.211 9.317a7.537 7.537 0 01-.803-.917C4.57 7.26 4.363 6.126 5.377 5.41c.073-.052.157-.118.245-.194C5.107 3.877 4.29 2.76 3.268 2.012c-.421.07-.87.437-1.255.88-.504.579-.873 1.261-.97 1.642a.694.694 0 00-.013.069c-.157 1.17.323 2.37 1.055 3.462 1.058 1.58 2.635 2.928 3.653 3.69a10.055 10.055 0 00.473-2.44v.002z","fill":"#1269A3"}})])
          )
        }
      }
    